import { createContext } from "react"

const actsContext = createContext({})

export default actsContext
